import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  response: null,
  error: null,
};

const updateUserSlice = createSlice({
  name: "updateUser",
  initialState,
  reducers: {
    updateUserRequest: (state) => {
      state.loading = true;
      state.error = null;
      state.response = null;
    },
    updateUserRequestSuccess: (state, action) => {
      state.loading = false;
      state.response = action.payload;
    },
    updateUserRequestError: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  updateUserRequest,
  updateUserRequestSuccess,
  updateUserRequestError,
} = updateUserSlice.actions;

export default updateUserSlice.reducer;
